





















import { Redirection } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { EVENTS } from '../../bus/events.const';
import { SUBMODULES_PATHS } from '../../store';
import { CONFIG_GETTERS_KEYS } from '../../store/config/config.const';

@Component({
  computed: {
    ...mapGetters(SUBMODULES_PATHS.config, {
      components: CONFIG_GETTERS_KEYS.components
    })
  }
})
export default class RedirectionsSuggestions extends Vue {

  @Prop({ required: true })
  suggestions: Redirection[];

  @Prop({ required: true })
  highlightedEmpathizeItem: any;

  @Prop({ default: EVENTS.RedirectionClicked })
  event: string;
}
